import { Screen } from "@Components/Page";
import { WorkflowOverview } from "@Components/Workflows/Overview";
import { Workflow } from "@Components/Workflows/Workflow";
import React from "react";
export function Workflows() {
    const [type, setType] = React.useState(null);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Screen, {
        hidden: !!type
    }, /*#__PURE__*/ React.createElement(WorkflowOverview, {
        onOpenWorkflow: setType
    })), type && /*#__PURE__*/ React.createElement(Workflow, {
        type: type,
        onExit: ()=>setType(null)
    }));
}
